import { render, staticRenderFns } from "./SelectSubstituteModal.vue?vue&type=template&id=35157584&scoped=true"
import script from "./SelectSubstituteModal.vue?vue&type=script&lang=ts"
export * from "./SelectSubstituteModal.vue?vue&type=script&lang=ts"
import style0 from "./SelectSubstituteModal.vue?vue&type=style&index=0&id=35157584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35157584",
  null
  
)

export default component.exports